var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiko(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "url(#paint0_linear_494_648)",
    stroke: "#6DBE99",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.053 15.3372L16.5683 12.7947L16.9241 12.1845C17.7149 10.8331 19.172 10 20.7476 10H30.4823L38.3112 23.4123H35.3437L30.162 14.5353C29.4424 13.3013 28.1099 12.5405 26.6707 12.5405H19.684L18.053 15.3352V15.3372ZM39.4084 25.2918L39.2265 24.9788H36.259L37.7161 27.4763L34.2208 33.4627C33.5012 34.6968 32.1687 35.4576 30.7294 35.4576H20.4372L18.9525 38H34.5391L39.4084 29.6608C40.1972 28.3094 40.1972 26.6451 39.4084 25.2937V25.2918ZM12.1319 29.4692C11.4123 28.2351 11.4123 26.7136 12.1319 25.4795L17.1396 16.9017L15.6549 14.3593L8 27.4743L12.8693 35.8155C13.6581 37.1669 15.1152 37.998 16.6928 37.998H17.1277L18.6125 35.4556H15.6292L12.1339 29.4692H12.1319ZM15.8961 28.196L18.1973 32.1387L26.2021 18.4291L23.9009 14.4864L15.8981 28.196H15.8961ZM32.7657 29.6765L30.4645 25.7337L28.3333 29.387L30.6345 33.3297L32.7657 29.6765ZM29.4305 23.9619L27.1293 20.0191L21.8824 29.0076L24.1836 32.9503L29.4305 23.9619Z",
    fill: "url(#paint1_linear_494_648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_494_648",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006F40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_494_648",
    x1: 8,
    y1: 23.999,
    x2: 39.9995,
    y2: 23.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94ED89"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiko);
export default __webpack_public_path__ + "static/media/PIKO.cd29f4ab.svg";
export { ForwardRef as ReactComponent };